import { ProductType } from "@/pricing/__generated__/ProductPricingDetailsFragment.graphql"
import ExperienceSettingsLabel from "@/product/settings/ExperienceSettingsLabel"
import { useAdminProductLabel } from "@/product/util/hook/useProductLabel"
import { GlobalID } from "@/relay/RelayTypes"
import Relay from "@/relay/relayUtils"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoFormControl, DiscoIcon, DiscoIconButton, DiscoInput } from "@disco-ui"
import { useCopyToClipboard } from "@utils/dom/domUtils"
import { TestIDProps } from "@utils/typeUtils"

interface ExperienceSettingsAdditionalDetailsProps extends TestIDProps {
  productId: GlobalID
  productType?: Extract<ProductType, "course" | "pathway">
}

function ExperienceSettingsAdditionalDetails({
  productId: globalProductId,
  productType = "course",
}: ExperienceSettingsAdditionalDetailsProps) {
  const classes = useStyles()
  const copyToClipboard = useCopyToClipboard()
  const productId = Relay.fromGlobalId(globalProductId).id

  const productLabel = useAdminProductLabel(productType)

  return (
    <DiscoFormControl
      label={
        <ExperienceSettingsLabel
          title={`${productLabel.singular} ID`}
          tooltipContent={`The internal Disco ID for this ${productLabel.singular}. This ID is unique to this ${productLabel.singular} and can be used with the Disco-Zapier integration.`}
        />
      }
      testid={`ExperienceSettingsAdditionalDetails.ProductId`}
      sublabel={`This ID is unique to this ${productLabel.singular} and can be used with the Disco-Zapier integration.`}
      className={classes.productIdContainer}
    >
      <DiscoInput
        disabled={true}
        value={productId}
        fullWidth
        classes={{ input: classes.input, root: classes.inputRoot }}
        endAdornment={
          <DiscoIconButton
            style={{ padding: 0 }}
            onClick={() => copyToClipboard(productId)}
          >
            <DiscoIcon icon={"copy"} />
          </DiscoIconButton>
        }
      />
    </DiscoFormControl>
  )
}

const useStyles = makeUseStyles({
  productIdContainer: {
    display: "flex",
    flexDirection: "column",
  },
  inputRoot: {
    flexWrap: "wrap",
    height: "40px",
  },
  input: {
    flex: "1 0 fit-content",
  },
})

export default ExperienceSettingsAdditionalDetails
